import ConfirmEmailChange from "./ConfirmEmailChange";

export default ConfirmEmailChange;

